module.exports = __webpack_public_path__ + "assets/img/meeting-2026-link.843dbe3e.jpg";